module.exports = __webpack_public_path__ + "static/media/rnaapp_112.8e7e0ccd.ico";